var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.25134C0.5 2.46329 0.5 2.06927 0.63589 1.76828C0.755416 1.50352 0.946144 1.28826 1.18074 1.15337C1.44743 1 1.79655 1 2.49481 1H7.23247C7.93071 1 8.27987 1 8.54655 1.15337C8.78112 1.28826 8.97188 1.50352 9.09138 1.76828C9.22727 2.06927 9.22727 2.46329 9.22727 3.25134V11.4764C9.22727 12.1832 9.22727 12.5366 9.09736 12.7265C8.98428 12.8919 8.81198 12.992 8.62702 12.9997C8.41458 13.0087 8.15974 12.8032 7.65013 12.3924L4.86364 10.1461L2.07713 12.3924C1.56752 12.8032 1.31271 13.0087 1.10027 12.9997C0.915319 12.992 0.742974 12.8919 0.629887 12.7265C0.5 12.5366 0.5 12.1832 0.5 11.4764V3.25134Z",
    stroke: "#27387D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.ecd7a4adcdcaf82075f408daa7a0ddcd.svg";
export { ForwardRef as ReactComponent };